import React, { useCallback, useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useRowConfig } from '../../../../../hooks';
import { useInventoryPermissions } from '../../../../../hooks/useInventoryPermissions';
import { getAutoInventoryBadge } from '../../../../../utils/badges';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { RowBase } from '../../../../Table/RowBase/RowBase';
import type { InventoryValue } from '../../../inventoryStatusUtils';

const RoomStockRowComponent: React.FC<{ roomId: number }> = ({ roomId }) => {
  const { inventoryRooms, formatter, onDuplicate } = useRowConfig({
    entityId: roomId,
    entityType: InventoryTabItemName.Rooms,
    fieldName: 'remainingStock',
    formatterName: 'remainingStock',
  });
  const { canEditStock } = useInventoryPermissions();
  const { hotelInfo } = useContext(HotelContext);
  const { roomsList } = useContext(ModernHotelContext);
  const room = roomsList.find((r) => r.id === roomId);

  const handleGetBadge = useCallback(
    (values: InventoryValue) => {
      const roomValues = values as RoomOpeningInventory;

      return getAutoInventoryBadge({
        stockScrapperEnabled: hotelInfo?.stockScrapperEnabled ?? false,
        bookingcomId: room?.bookingcomId,
        isAutomated: roomValues.isStockAutomated,
        value: roomValues.remainingStock,
      });
    },
    [hotelInfo?.stockScrapperEnabled, room?.bookingcomId]
  );

  if (!inventoryRooms) {
    return null;
  }

  return (
    <RowBase
      label="Remaining stock"
      entityId={roomId}
      fieldName="remainingStock"
      entityType={InventoryTabItemName.Rooms}
      formatter={formatter}
      onDuplicate={onDuplicate}
      isEditable={canEditStock}
      defaultValue={0}
      getBadge={handleGetBadge}
    />
  );
};

export const RoomStockRow = React.memo(RoomStockRowComponent);
